module.exports = __webpack_public_path__ + "img/1723614870804-WhatsApp Image 2024-08-14 at 13.45.28.jpeg.61d341c6.webp";